@if (appConfig.initialized && this.teams) {
  <mat-toolbar
    color="primary"
    role="navigation"
    class="app-toolbar"
    [ngClass]="{ 'staging-toolbar': isTenantStagingConnection }"
  >
    @if (isLoggedIn) {
      <button
        mat-icon-button
        (click)="toggleSidenav()"
        class="mobile-only"
        aria-label="Show or hide the menu"
      >
        <mat-icon>menu</mat-icon>
      </button>
    }
    <a
      mat-button
      class="logo-link"
      [routerLink]="['/home']"
      [attr.title]="title"
    >
      @if (isEnvironmentStaging) {
        <img
          alt="Lineup Staging Home"
          src="../assets/img/LineupLogoStaging.png"
        />
      } @else {
        <img alt="Lineup Home" src="../assets/img/LineupLogo.png" />
      }
      <h1>{{ title }}</h1>
    </a>
    @if (isLoggedIn) {
      <workspace-nav></workspace-nav>
      @if (isTestModeEnabled) {
        <app-warning-banner>
          Lineup is running in <strong>Test Mode</strong>.
        </app-warning-banner>
      } @else {
        <span class="spacer"></span>
      }
    }
    <div class="desktop-only">
      @if (this.loggedInSystemUserHasLatestEula) {
        <a
          mat-button
          class="menu-button menu-with-dropdown"
          [routerLink]="['/teams']"
          [attr.title]="'Teams' | platformLabel"
          id="teams-link"
        >
          {{ 'Teams' | platformLabel }}
        </a>

        <button
          mat-icon-button
          yPosition="before"
          [matMenuTriggerFor]="teamsMenu"
          class="dropdown-arrow"
          [attr.aria-label]="'Teams submenu' | platformLabel"
        >
          <mat-icon>arrow_drop_down</mat-icon>
        </button>

        <a
          mat-button
          class="menu-button"
          [routerLink]="['/people']"
          [attr.title]="'People'"
          id="people-link"
        >
          People
        </a>

        <a
          mat-button
          class="menu-button"
          [routerLink]="['/credential-applications']"
          [attr.title]="'Applications'"
          id="applications-link"
          [allowModule]="tenantModuleType.Credentials"
        >
          Applications
        </a>

        <button
          mat-button
          [matMenuTriggerFor]="toolsMenu"
          #toolsMenuTrigger="matMenuTrigger"
          (mouseenter)="onToolsMenuTriggerEnter(toolsMenuTrigger, $event)"
          (mouseleave)="onToolsMenuTriggerLeave()"
          class="menu-button"
          [attr.aria-label]="'Tools'"
          id="tools-link"
        >
          Tools
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>

        @if (isAdmin()) {
          <a
            mat-button
            class="menu-button"
            [routerLink]="['/admin']"
            [attr.title]="'Admin'"
          >
            Admin
          </a>
        }
      }
      <button mat-button class="menu-button" (click)="openWidget()">
        Support
      </button>
      @if (profile) {
        <button
          mat-button
          [matMenuTriggerFor]="authMenu"
          #authMenuTrigger="matMenuTrigger"
          (mouseenter)="onAuthMenuTriggerEnter(authMenuTrigger, $event)"
          (mouseleave)="onAuthMenuTriggerLeave()"
          class="menu-button profile-button"
          attr.aria-label="{{ profile.given_name }} Account"
          id="profile-button"
        >
          {{ profile.given_name }}
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>
      }
    </div>
    @if (isLoggedIn) {
      <button
        class="mobile-only"
        mat-icon-button
        [matMenuTriggerFor]="menu"
        aria-label="Open account menu"
      >
        <mat-icon>account_circle</mat-icon>
      </button>
    }
    <mat-menu #menu>
      <a [routerLink]="['/exports']" mat-menu-item>Exports</a>
      @if (canChangePassword | async) {
        <button (click)="changePassword()" mat-menu-item>
          Change password
        </button>
      }
    </mat-menu>
    <mat-menu #teamsMenu>
      <button
        mat-menu-item
        [routerLink]="['/teams']"
        [attr.title]="'Teams' | platformLabel"
      >
        {{ 'All Active Teams' | platformLabel }}
      </button>
      <mat-divider></mat-divider>
      <h3 class="menu-item-header">Recent</h3>
      @for (team of activeTeams(); track team) {
        <button
          mat-menu-item
          [routerLink]="['/teams', team.id]"
          [attr.title]="team?.name"
          routerLinkActive="router-link-active"
        >
          {{ team?.name }}
        </button>
      }
      @if (isManager()) {
        <mat-divider></mat-divider>
      }
      @if (isManager()) {
        <button
          mat-menu-item
          class="add-team"
          (click)="openDialog()"
          [attr.aria-label]="'Create a new team' | platformLabel"
        >
          {{ 'Create New Team' | platformLabel }}
        </button>
      }
    </mat-menu>
    <mat-menu #authMenu [hasBackdrop]="false">
      <div
        (mouseenter)="cancelAuthMenuClose()"
        (mouseleave)="scheduleAuthMenuClose()"
      >
        <a
          mat-menu-item
          href="https://www.lineupteams.com/privacy-policy"
          target="_blank"
          [attr.title]="'Privacy Policy'"
        >
          Privacy Policy
        </a>
        <a
          mat-menu-item
          href="https://support.lineupteams.com/hc/en-us/sections/360006008474-Release-Notes"
          target="_blank"
          [attr.title]="'Release Notes'"
        >
          Release Notes
        </a>
        <a
          mat-menu-item
          href="https://support.lineupteams.com/hc/en-us/community/topics"
          target="_blank"
          [attr.title]="'Lineup Community'"
        >
          Lineup Community
        </a>
        @if (this.loggedInSystemUserHasLatestEula) {
          <button mat-menu-item [routerLink]="['/exports']">Exports</button>
        }
        @if (
          (canChangePassword | async) && this.loggedInSystemUserHasLatestEula
        ) {
          <button mat-menu-item mat-menu-item (click)="changePassword()">
            Change password
          </button>
        }
        <button mat-menu-item (click)="logout()" id="logout-button">
          Log Out
        </button>
      </div>
    </mat-menu>
    <mat-menu #toolsMenu [hasBackdrop]="false">
      <!-- mat-menu's own host element is display:none; hover listeners must live on
           projected content (this div), which is what actually renders in the panel -->
      <div
        (mouseenter)="cancelToolsMenuClose()"
        (mouseleave)="scheduleToolsMenuClose()"
      >
        <a mat-menu-item [routerLink]="['/reports']" [attr.title]="'Reports'">
          Reports
        </a>
        <a mat-menu-item [routerLink]="['/import']" [attr.title]="'Imports'">
          Imports
        </a>
      </div>
    </mat-menu>
  </mat-toolbar>
}
@if (isLoading) {
  <mat-progress-bar
    mode="indeterminate"
    class="app-progress-bar"
  ></mat-progress-bar>
}
<router-outlet></router-outlet>
